export function getUrlType(input) {
  try {
    // Try parsing the input as a URL
    const url = new URL(input);
    return "URL";
  } catch (error) {
    // If parsing fails, check if it's a domain or subdomain
    const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (domainPattern.test(input)) {
      const parts = input.split(".");
      return parts.length > 2 ? "sub-domain" : "domain";
    }
    return "Invalid";
  }
}

export function getDomainParts(url) {
  const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([^\/]+)/i);
  if (!match) return { subdomain: "", domain: "" };

  const hostname = match[1].trim();
  const parts = hostname.split(".");

  if (parts.length < 2) {
    return { subdomain: "", domain: hostname };
  }

  let domainParts = [];
  let subdomainParts = [];

  for (let i = parts.length - 1; i >= 0; i--) {
    domainParts.unshift(parts[i]);

    // If last two parts fit the rule of SLD+TLD (e.g., "com.au", "co.uk"), continue adding
    if (domainParts.length >= 2) {
      if (
        domainParts[domainParts.length - 2].length <= 3 &&
        domainParts[domainParts.length - 1].length <= 2
      ) {
        continue;
      }
    }

    if (domainParts.length >= 2) {
      subdomainParts = parts.slice(0, i);
      break;
    }
  }

  return {
    subdomain: subdomainParts.join(".") || "",
    domain: domainParts.join("."),
  };
}

export function isValidURL(string) {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
      "(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-zA-Z\\d_]*)?$",
    "i" // fragment locator
  );
  return !!pattern.test(string);
}